import angular from 'angular';

import CategoryColorModule from './category-color';
import CategoryModule from './category';
import EventEditModalModule from './event-edit-modal';
import EventDateModalModule from './event-date-modal';
import EventDetailsModalModule from './event-details-modal';
import EventReceiptModalModule from './event-receipt-modal';
import EventRepeatChangeModalModule from './event-repeat-change-modal';
import EventRepeatDeleteModalModule from './event-repeat-delete-modal';
import EventListModalModule from './event-list-modal';
import CategorySelectModalModule from './category-select-modal';
import CategoryManageModalModule from './category-manage-modal';
import CategoryEditModalModule from './category-edit-modal';
import CategoryMergeModalModule from './category-merge-modal';
import CalendarEditModalModule from './calendar-edit-modal';
import CalendarSelectDefaultModalModule from './calendar-select-default-modal';
import CalendarSelectModalModule from './calendar-select-modal';
import ConfirmModalModule from './confirm-modal';
import TeamEditModalModule from './team-edit-modal';
import EmailIngestTokenModalModule from './email-ingest-token-modal';
import CollaboratorInviteModalModule from './collaborator-invite-modal';
import CollaboratorManageModalModule from './collaborator-manage-modal';
import DateModalModule from './date-modal';

export default angular
    .module('application.component.modals.component', [
        CategoryColorModule.name,
        CategoryModule.name,
        EventEditModalModule.name,
        EventDateModalModule.name,
        EventDetailsModalModule.name,
        EventReceiptModalModule.name,
        EventRepeatChangeModalModule.name,
        EventRepeatDeleteModalModule.name,
        EventListModalModule.name,
        CategorySelectModalModule.name,
        CategoryManageModalModule.name,
        CategoryEditModalModule.name,
        CategoryMergeModalModule.name,
        CalendarEditModalModule.name,
        CalendarSelectDefaultModalModule.name,
        CalendarSelectModalModule.name,
        ConfirmModalModule.name,
        TeamEditModalModule.name,
        EmailIngestTokenModalModule.name,
        CollaboratorInviteModalModule.name,
        CollaboratorManageModalModule.name,
        DateModalModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/index.js